var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInstagramPost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "#ffce00",
    r: 256
  }))))))), /*#__PURE__*/React.createElement("path", {
    d: "m512 256c0-7.382-.313-14.69-.925-21.913l-149.453-149.453-211.143 340.838 85.778 85.778c6.516.497 13.1.75 19.743.75 141.385 0 256-114.615 256-256z",
    fill: "#ffa300"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.008 433.209h-174.016c-14.375 0-26.028-11.653-26.028-26.028v-304.362c0-14.375 11.653-26.028 26.028-26.028h174.015c14.375 0 26.028 11.653 26.028 26.028v304.362c.001 14.375-11.652 26.028-26.027 26.028z",
    fill: "#636978"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m343.008 76.791h-86.649v356.418h86.649c14.375 0 26.028-11.653 26.028-26.029v-304.361c0-14.375-11.653-26.028-26.028-26.028z",
    fill: "#414952"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m166.082 105.09h179.837v287.72h-179.837z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.71 189.238-131.481 34.21v-86.553h131.481z",
    fill: "#80dbff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.71 136.895h-65.351v69.347l65.351-17.004z",
    fill: "#4ab8f7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m190.229 223.448 39.391-48.979 24.76 19.548 31.276-34.751 36.054 29.972v34.21z",
    fill: "#00c8c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m321.71 189.238-36.054-29.972-29.297 32.551v31.631h65.351z",
    fill: "#00a0aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m235.267 250.535c0-6.384-5.175-11.56-11.559-11.56-5.245 0-9.674 3.493-11.088 8.281-1.413-4.787-5.843-8.281-11.088-8.281-6.384 0-11.559 5.176-11.559 11.56 0 12.857 22.647 26.304 22.647 26.304s22.647-12.149 22.647-26.304z",
    fill: "#ff7d81"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m190.09 294.36h131.62v23.784h-131.62z",
    fill: "#afb4c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.359 294.36h65.351v23.784h-65.351z",
    fill: "#7e8596"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m190.09 339.537h131.62v23.785h-131.62z",
    fill: "#afb4c8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.359 339.537h65.351v23.784h-65.351z",
    fill: "#7e8596"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstagramPost);
export default __webpack_public_path__ + "static/media/icon-instagram-post.23336e402f3afcbb34891b2aec3f6c72.svg";
export { ForwardRef as ReactComponent };